import { Base } from "@app/controllers/base";
import { TrackingChannel } from "@app/channels/store/tracking_channel";

// Connects to data-controller="store-page--tracking"
export default class extends Base {
  static values = { code: String }

  connect() {
    console.log("Tracking controller connected with code:", this.codeValue);
    this.subscriptions = {};
    this.subscribeChannel();
  }

  disconnect() {
    if (this.subscriptions.trackingChannel) {
      this.subscriptions.trackingChannel.disconnect();
      delete this.subscriptions.trackingChannel;
    }
  }

  async subscribeChannel() {
    this.trackingChannel = new TrackingChannel({
      channel: "Store::TrackingChannel",
      params: {
        code: this.codeValue,
      },
      attributes: {
        trackingController: this,
      }
    });

    this.subscriptions = {
      trackingChannel: await this.trackingChannel.subscribe(),
    }
  }

  handleMessage(data) {
    if (data.action === "timeline_updated") {
      console.log(`Live update: Timeline ${data.timeline_type} menjadi ${data.status}`);

      if (window.Turbo) {
        Turbo.visit(window.location.href, { action: "replace" });
      } else {
        window.location.reload();
      }
    } else if (data.action === "refresh_video") {
      console.log("Live update: Refreshing video output frame...");
      const videoFrame = document.getElementById("video_output_frame");
      
      if (videoFrame) {
        videoFrame.src = window.location.href;
      }
    }
  }

}
